import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useState, useMemo } from 'react';
import { FilterProps } from '../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { CompanyRoleAssignmentFilter } from '../../CompanyRoleAssignmentFilter';
import { CompanyRoleAssignmentUtil } from '../../../../../types/company_role_assignment/companyRoleAssignment.util';

interface CompanyRoleAssignmentFilterDropdownContentProps {
  filter: CompanyRoleAssignmentFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function CompanyRoleAssignmentFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
}: CompanyRoleAssignmentFilterDropdownContentProps) {
  const [query, setQuery] = useState<string>('');

  const values = useMemo(() => {
    return new Set(filter.companyRoles.filter(role => filter.search(role, query)).map(role => role.role));
  }, [query, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.role = selected;
    if (!filterProps.role?.size) filterProps.role = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.role = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{t(TranslationKey.role).singular.label}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.role || new Set()}
          values={values}
          onChange={handleChange}
          toText={id => CompanyRoleAssignmentUtil.roleToString(filter.companyRoles.find(cr => cr.role === id)?.role)}
        />
      </Grid>
    </Grid>
  );
}
